<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" title="수정한 관리자">
        <v-container>
          <v-row align="center" v-if="openFlag">
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">이름</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogAdminData.name }}</span>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">로그인ID</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogAdminData.loginId }}</span>
            </v-col>
          </v-row>
          <v-row justify="center">
            <c-btn class="mt-2" color="gray" outlined @click="openFlag = false">닫기</c-btn>
          </v-row>
        </v-container>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false
      },
      driveLogAdminData: {
        type: Object,
        default: undefined
      }
    },
    data: () => ({
      openFlag: false,
    }),
    watch: {
      open(newVal) {
        this.openFlag = newVal;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    }
  }
</script>
